export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/audio-list.ab8f1376.svg","height":114,"width":114,"blurWidth":0,"blurHeight":0};